var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserValidate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 77,
    viewBox: "0 0 56 77",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.138 8.195a.667.667 0 1 0-.943.943l3.334 3.333c.26.26.682.26.942 0l7.334-7.333a.667.667 0 0 0-.943-.943L6 11.057 3.138 8.195z",
    id: "qlyqm3g0aa"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.007 22.7c-.296.794-.807 1.715-1.344 1.945-.61.26-.863.626-.863.626l-.492-.285-.587-.341s.014-.066.043-.172c.028-.106.072-.253.132-.416 0 0 .18-.231.07-.522-.111-.29-.089-.74.1-1.014.188-.273.37-.948.483-.928.274.048-.135.974-.017 1.146.106.156.239.102.263.09l.005-.002c.77-.339 1.705-2.164 2.118-1.918.155.092.214 1.454.089 1.792",
    fill: "#D88779"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.342 23.806.965.678a.152.152 0 0 0 .21-.037l2.473-3.517a.152.152 0 0 0-.037-.21l-.965-.679a.152.152 0 0 0-.211.037l-2.472 3.517a.152.152 0 0 0 .037.21",
    fill: "#2B478B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.225 24.427.566.397a.116.116 0 0 0 .16-.028l2.514-3.576a.116.116 0 0 0-.028-.16l-.566-.398a.116.116 0 0 0-.16.028l-2.514 3.576a.116.116 0 0 0 .028.16",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.497 18.76s4.91 8.562 6.692 10.138l6.532-4.869s.948.29 1.363 1.242c0 0-3.966 8.08-7.872 8.422-3.906.343-9.387-9.684-9.387-9.684l2.672-5.25z",
    fill: "#F2564B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.385 77H7.548c-.357-.194-.676-.638-.776-1.3-.139-.914-1.163-1.412-1.385-2.16-.221-.747.914-1.799.914-1.799l.19-.244.198-.254 1.883.443s.046.448.075 1.02c.02.412.03.888.008 1.305-.056.997.279 2.07 1.164 2.264.655.144.626.532.566.725M26.85 77h-6.488c-.312-.38-.197-1.786-.15-2.244a9.03 9.03 0 0 1 .017-.147s2.216-1.772 2.52-.415c.01.043.02.084.033.125.383 1.27 2.103 1.846 3.096 2.007.646.104.885.44.973.674",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.615 40.79s-.337 4.197-.732 9.241c-.538 6.853-1.184 15.27-1.248 16.865-.11 2.77-.554 7.198-.554 7.198s-1.052 1.052-3.157.609c0 0-1.876-6.323-2.411-13.013l-.025-.33c-.499-6.81-1.274-21.151-1.274-21.151l9.4.581z",
    fill: "#3A4ACE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.615 40.79s-.337 4.197-.732 9.241l-7.37 11.66-.025-.331c-.499-6.81-1.274-21.151-1.274-21.151l9.4.581z",
    fill: "#293EB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.078 41.288s-6.064 15.2-10.051 22.342c-3.988 7.142-5.234 9.135-5.234 9.135s-2.284-.913-2.492-1.536c0 0 1.525-13.79 4.195-17.15 1.509-1.9 3.281-7.6 3.364-9.593.084-1.993.54-5.938.54-5.938l9.678 2.74z",
    fill: "#3A4ACE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.569 19.132c-2.37.747-6.47-1.27-6.47-1.27s2.184-1.64 2.07-5.048l1.832 1.476 1.245 1.003s-.005.59-.141 1.627c-.036.272-.08.576-.137.908a5.67 5.67 0 0 1 1.6 1.304",
    fill: "#F7A491"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.246 15.293s-.005.59-.141 1.627c-1.38-.237-2.944-2.465-2.944-2.465.703-.203 1.317-.24 1.84-.165l1.245 1.003z",
    fill: "#D88779"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.97 15.236s-3.913.65-4.281-1.793c-.367-2.443-1.12-4.005 1.364-4.523 2.483-.518 3.11.34 3.431 1.126.321.786.495 4.958-.513 5.19",
    fill: "#F7A491"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.876 41.14a.383.383 0 0 1-.249.094c-.89-.012-3.485.482-5.68.257-1.852-.178-3.49-.726-5.25-1.514-.233-.105-.77-.392-.759-.653.008-.286.037-.7.072-1.223.125-1.815.342-4.938.13-8.541a37.74 37.74 0 0 1-.06-1.992c-.018-4.883.95-9.178 2.896-10.631.166-.12 1.187.38 2.124.842.867.427 1.733.474 2.552.308l.818.724c.997.925 2.089 2.183 2.563 4.093.404 1.625.641 4.556.772 7.593.059 1.376.107 2.765.119 4.082v.047c.011.13.011.273.011.404.048 3.38 0 6.062-.059 6.11",
    fill: "#FB7369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.01 38.101c.125-1.815.342-4.938.13-8.541a37.68 37.68 0 0 1-.06-1.992c.81-1.966 1.473-3.392 1.473-3.392h2.043s1.498 10.23-3.586 13.925",
    fill: "#F2564B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.384 43.038-8.715-1.242a2.089 2.089 0 0 0-2.356 1.768l-.538 3.776a2.089 2.089 0 0 0 1.768 2.355l8.715 1.242a2.09 2.09 0 0 0 2.356-1.768l.538-3.776a2.089 2.089 0 0 0-1.768-2.355",
    fill: "#143DB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.069 41.297a.258.258 0 0 1 .291-.219l.387.055 1.434.205.782.111c.14.02.239.15.219.291l-.116.815-3.113-.444.116-.814zm6.807 2.866a2.098 2.098 0 0 0-1.444-1.26l-.002-.001a2.091 2.091 0 0 0-.201-.04l-1.735-.246.116-.815a.686.686 0 0 0-.586-.78l-.453-.065-1.822-.26-.328-.046a.69.69 0 0 0-.78.586l-.116.814-2.995-.427a2.097 2.097 0 0 0-2.365 1.775l-.545 3.82a2.096 2.096 0 0 0 1.775 2.364l8.7 1.24c.153.021.305.026.453.014h.002a2.094 2.094 0 0 0 1.91-1.79l.544-3.819a2.073 2.073 0 0 0-.128-1.064z",
    fill: "#2E5BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.686 39.449a5.32 5.32 0 0 1 .008-.143c.019-.244.476-.853.476-.853l-1.147-.596-.454.75c-.687.547-.7.557-.574 1.602.108.906-.485.916-.47 1.563.014.648.848.33.848.33 1.292-.607 1.399-.912 1.36-1.527.122.173.259.275.375.199.103-.067-.102-.332-.191-.945-.013-.092-.122-.245-.231-.38",
    fill: "#F7A491"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.007 38.92c.735.143 1.533.085 1.533.085s2.184-6.746 2.466-7.363c.28-.616 6.488-7.91 6.488-7.91l-2.586-6.47s-6.714 11.212-7.395 12.787c-1.127 2.604-1.518 8.44-1.518 8.44s.434.318 1.012.43",
    fill: "#FB7369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.686 13.208s.401-.067.337-.62c-.065-.553-.064-1.276.386-1.142.45.135.472.495.657.285.184-.21.188-1.096 1.526-1.158 1.339-.062 1.883.404 2.505.13.622-.273.655-1.215.655-1.215s-.177.337-.444.443c0 0 1.038-1.42-.164-2.393-1.202-.974-2.428-.336-3.124-.294-1.533.092-2.523.184-3.024 1.191-.5 1.008-.294 3.804.69 4.773",
    fill: "#1D273B"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#08CA86",
    fillRule: "nonzero",
    cx: 10,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b62zlv125b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#qlyqm3g0aa"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#qlyqm3g0aa"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b62zlv125b)",
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserValidate);
export default __webpack_public_path__ + "static/media/userValidate.24c6ac0f81e488cfe66cbfbe1a678ba2.svg";
export { ForwardRef as ReactComponent };